import 'abortcontroller-polyfill';
import 'core-js/features/promise';
import 'es5-shim';
import 'es6-shim';
import 'es7-shim';
import promiseFinally from 'promise.prototype.finally';
import './forie';

promiseFinally.shim();



// WEBPACK FOOTER //
// ./src/polyfill.ts